<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <section class="mb-12 p-12">
      <p class="mx-4 text-gray-600 font-bold uppercase mb-4">
        Recogida de datos
      </p>
      <div class="flex flex-wrap">
        <v-text-field
          label="Centro"
          class="mx-4"
          :value="$root.centro ? $root.centro.title : ''"
          filled
          readonly
        ></v-text-field>
      </div>
      <div class="flex flex-wrap">
        <v-text-field
          label="Nombre"
          class="mx-4"
          :value="$root.alumno ? $root.alumno.nombre : ''"
          filled
          readonly
        ></v-text-field>
        <v-text-field
          label="Apellidos"
          class="mx-4"
          :value="$root.alumno ? $root.alumno.apellidos : ''"
          filled
          readonly
        ></v-text-field>
      </div>
      <div class="flex flex-wrap">
        <v-text-field
          :value="$root.alumno ? $root.alumno.ID_Alumno : ''"
          label="ID Alumno"
          readonly
          filled
          class="mx-4"
        ></v-text-field>
        <v-text-field
          :value="$root.alumno ? $root.alumno.ID_Curso : ''"
          label="Curso"
          readonly
          filled
          class="mx-4"
        ></v-text-field>
      </div>
      <div class="flex flex-wrap">
        <v-text-field
          label="Nombre Contacto"
          v-model="form.nombre_contacto"
          :rules="[(v) => !!v || 'Nombre contacto es requerido.']"
          outlined
          required
          class="mx-4"
        ></v-text-field>
        <v-text-field
          label="Apellidos Contacto"
          v-model="form.apellidos_contacto"
          :rules="[(v) => !!v || 'Apellidos contacto es requerido.']"
          outlined
          required
          class="mx-4"
        ></v-text-field>
      </div>
      <div class="flex flex-wrap">
        <v-text-field
          label="DNI Contacto"
          v-model="form.dni_contacto"
          :rules="[(v) => !!v || 'DNI contacto es requerido.']"
          outlined
          required
          class="mx-4"
        ></v-text-field>
        <v-text-field
          label="Email Contacto"
          v-model="form.email_contacto"
          :rules="[
            (v) => !!v || 'Email contacto es requerido.',
            (v) => /.+@.+/.test(v) || 'Email contacto no válido.',
          ]"
          outlined
          required
          class="mx-4"
        ></v-text-field>
      </div>
      <div class="flex flex-wrap">
        <v-text-field
          label="Teléfono de contacto"
          v-model="form.telefono_contacto"
          :rules="[(v) => !!v || 'Teléfono de contacto es requerido.']"
          outlined
          required
          class="mx-4"
        ></v-text-field>
      </div>
      <p class="mx-4 text-gray-600 font-bold uppercase mb-4">Datos comercial</p>
      <div class="flex flex-wrap">
        <v-text-field
          label="Nombre comercial"
          class="mx-4"
          v-model="form.nombre_comercial"
          :rules="[(v) => !!v || 'Nombre comercial es requerido.']"
          outlined
          required
        ></v-text-field>
        <v-text-field
          label="Email comercial"
          class="mx-4"
          v-model="form.email_comercial"
          :rules="[
            (v) => !!v || 'Email comercial es requerido.',
            (v) => /.+@.+/.test(v) || 'Email comercial no válido.',
          ]"
          outlined
          required
        ></v-text-field>
      </div>
      <p class="text-gray-600 font-bold uppercase m-4">Dispositivo</p>
      <v-data-table
        v-model="form.dispositivos"
        :headers="headers"
        :items="$root.dispositivos"
        item-key="num"
        show-select
        single-select
        disable-pagination
        disable-filtering
        hide-default-footer
        class="elevation-1 mx-4"
      >
      </v-data-table>
      <p class="text-gray-600 font-bold uppercase m-4">Modelo Renove</p>
      <v-flex align-center justify-between class="mx-4 mb-4">
        <v-flex>
          <v-autocomplete
            v-model="form.modelo"
            :items="modelosRenove"
            label="Modelo"
            outlined
            required
            :rules="[(v) => !!v || 'Modelo renove es requerido.']"
            class="w-full mr-6"
          ></v-autocomplete>
          <v-switch v-model="form.funcional" inset label="Funcional"></v-switch>
        </v-flex>
        <v-spacer></v-spacer>
        <span
          ><b>Importe:</b>
          {{
            form.modelo
              ? form.funcional === false
                ? form.modelo.precio_ko
                : form.modelo.precio_ok
              : 0
          }}
          &euro;</span
        >
      </v-flex>
      <div class="flex flex-wrap mx-4">
        <div class="w-1/2">
          <p class="text-gray-600 font-bold uppercase mb-4">Estado iCloud:</p>
          <v-radio-group
            v-model="form.icloud"
            required
            :rules="[(v) => !!v || 'Estado iCloud es requerido.']"
          >
            <v-radio
              v-for="(estado, index) in estados"
              :key="index"
              :label="estado"
              :value="estado"
            ></v-radio>
          </v-radio-group>
        </div>
        <div class="w-1/2">
          <v-textarea
            outlined
            label="Observaciones"
            v-model="form.observaciones"
          ></v-textarea>
        </div>
      </div>
    </section>
    <v-flex justify-between>
      <v-btn text @click="$emit('change-step', step - 1)">volver</v-btn>
      <v-btn color="primary" :disabled="!valid" @click="next">continuar</v-btn>
    </v-flex>
  </v-form>
</template>

<script>
export default {
  name: "StepThree",

  props: {
    step: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          align: "start",
          text: "Num. Serie",
          value: "numero_de_serie",
        },
        {
          sortable: false,
          text: "Modelo",
          value: "modelo",
        },
      ],
      valid: false,
      form: {
        funcional: false,
        dispositivos: [],
        modelo: null,
        icloud: null,
        nombre_contacto: "",
        apellidos_contacto: "",
        dni_contacto: "",
        email_contacto: "",
        telefono_contacto: "",
        nombre_comercial: "",
        email_comercial: "",
        observaciones: "",
      },
      estados: ["Desactivado", "Gestionado por el centro"],
    };
  },

  computed: {
    modelosRenove() {
      return this.$root.modelosRenove.map((record) => {
        return {
          text: record.modelo,
          value: record,
        };
      });
    },
  },

  methods: {
    calculaImporte(value) {
      return value;
    },
    next() {
      if (this.$refs.form.validate()) {
        this.$root.form = this.form;
        this.$emit("change-step", this.step + 1);
      }
    },
  },
};
</script>
